var exports = {
  "i": "xaee3c4fa--b51666--wrapper",
};

module.exports = exports;
